<template>
  <b-nav-item class="cx_card_list_menu_item" @click="onClick" :disabled="enabled==false || $api.perms.hasMenuPermission(perm) == false" ref="tooltip_target">
    <i class="material-icons small valign" v-if="icon">{{ icon }}</i>
    <SvgIcon :name="svg" v-if="svg" :width="18" :height="18"/>
    {{ titleSC }}
  </b-nav-item>
</template>
<script lang="ts">
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';

@Component
export default class CardListMenu extends Vue {
  @Prop() public icon!: string;
  @Prop({default:null}) public svg: string;  
  @Prop() public title!: string;
  @Prop({ default: null }) public perm: string;
  @Prop({ default: null }) public sc: string;
  @Prop() public tooltip: string;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: true }) public event: boolean;  //GA4イベント

  public get titleSC() {
    if (this.sc == null) return this.$translate(this.title);
    else return this.$translate(this.title) + '(' + this.sc + ')';
  }
  //#region　フォーカス制御～Read以外の場合に確認ダイアログを表示する
  public created() {
    // if (this.sc != null) document.body.addEventListener('keydown', this.onKeyDown);
    if (this.sc != null) this.$api.sckeys.add(this.sc, this.onClick);
  }
  public mounted() {
    if(this.tooltip) this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip);
  }
  public destroyed() {
    // if (this.sc != null) document.body.removeEventListener('keydown', this.onKeyDown);
    if (this.sc != null) this.$api.sckeys.remove(this.sc, this.onClick);
  }

  public onClick(): boolean {
    if (this.$api.perms.hasMenuPermission(this.perm) && this.enabled) {
      if(this.event)this.$api.issueGA4event(this.$route.path,this.titleSC);
      this.$emit('click');
    }
    return true;
  }
}
</script>
<style lang="scss">
.cx_card_list_menu_item {
  /* min-width: 120px; */
  margin: 0px 3px;
  white-space: nowrap;
  font-size: 15px;
  position:static; //横スクロール対応
}

.navbar-light .navbar-nav .cx_card_list_menu_item .nav-link {
  color: rgb(26, 20, 20);

  &.disabled {
    color: rgb(117, 117, 117);
  }
}
.navbar-light .navbar-nav .cx_card_list_menu_item .nav-link:hover {
  color: #3194ff;
}
</style>
